module.exports = __webpack_public_path__ + "img/box6-22.95d11c23.png";